import React from "react";
import { useVisualHtmlEditorContext } from "./VisualHtmlEditor";
import { useDrop } from "react-dnd";

export const AddChild = ({acceptElements, acceptText, path, index}) => {

  const { addElement } = useVisualHtmlEditorContext();


  const [{ isOver }, drop] = useDrop(() => ({
    accept: [
      'HTML_BLOCK_ELEMENT', 'HTML_MOVE_ELEMENT'
    ],
    drop: (x, y) => {
      const data = y.getItem();
      addElement(data, path, index);
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  }), [path, index, addElement]);



  return (
    <>
      {(acceptElements !== false || acceptText !== false) && 
        <div ref={drop} className={isOver ? 'vhe-add-child-hover' : 'vhe-add-child'}></div>
      }
    </>
  )
}